import React from 'react';
import {List} from 'semantic-ui-react'

class AppSidebarNavStudents extends React.Component {
  render() {
    return (
      <List link>
        <List.Item>
          <List.Content as="a" className="active">
            Serve
          </List.Content>
        </List.Item>
        <List.Item>
          <List.Content as="a">
            Something
          </List.Content>
          <List link>
                    <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
          </List>
        </List.Item>
        <List.Item>
          <List.Content as="a">
            Beta
          </List.Content>
          <List link>
            <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
          </List>
        </List.Item>
        <List.Item>
          <List.Content as="a">
            Verifications
          </List.Content>
        </List.Item>
        <List.Item>
          <List.Content as="a">
            Gamma
          </List.Content>
          <List link>
            <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
          </List>
        </List.Item>
      </List>
    );
  }
}

AppSidebarNavStudents.displayName = 'AppSidebarNavStudents';
AppSidebarNavStudents.propTypes = {};
AppSidebarNavStudents.defaultProps = {};
export { AppSidebarNavStudents };



// WEBPACK FOOTER //
// ./src/components/app/sidebar/NavStudents.js